import { useState, useEffect } from "react";
import {
  Button,
  IconButton,
  Stack,
  ImageList,
  ImageListItem,
  TextField,
  Typography,
  InputAdornment,
  Modal,
  Box,
  useMediaQuery,
  useTheme,
  ImageListItemBar,
  Grid,
  Input,
  InputLabel
} from "@mui/material";
import PictureViewer from "../common/PictureViewer";
import {
  DELETE_EXPENSES,
  DELETE_EXPENSES_PICTURES,
  FETCH_EXPENSES,
  SAVE_EXPENSES,
  SAVE_EXPENSES_PICTURES
} from "../../constant/Apipath";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CalendarIcon, DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Postrequestcall } from "../../request/Postrequest";
import { useSelector } from "react-redux";
import Projectlist from "../common/Projectlist";
import PromptModal from "../common/PromptModal";
import { setDashboardData, setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../constant/EnglishFallback";

const Addexpenses = (props) => {
  const getPath = window.location.pathname.split("/").pop();
  const { loginData, multiLanguageData, dashboardData } = useSelector((state) => state?.main);
  let currentUserId = loginData?.userInformation?.UserId ?? 0;
  const [pictures, setPictures] = useState([]);
  const [selectedProjectDetails, setSelectedProjectDetails] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [imageIndex, setImageIndex] = useState(null);
  const [pictureViewer, setPictureViewer] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [openDatepicker, setOpenDatepicker] = useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [showProjects, setShowProjects] = useState(false);
  const [confirmDeleteExpenseModal, setConfirmDeleteExpenseModal] = useState(false);
  const [addExpensesData, setAddexpensesData] = useState({
    expenseId: 0,
    expDate: dayjs(),
    amount: "",
    description: "",
    comments: ""
  });
  const [errorMsg, setErrorMsg] = useState("");

  const LanguageData = multiLanguageData?.Expenses || {};
  const {
    TEXT_ADD_EXPENSES = English.Expenses.TEXT_ADD_EXPENSES,
    TEXT_EDIT_EXPENSES = English.Expenses.TEXT_EDIT_EXPENSES,
    TEXT_ADD_PICTURES = English.Expenses.TEXT_ADD_PICTURES,
    TEXT_EXPENSE_DATE = English.Expenses.TEXT_EXPENSE_DATE,
    TEXT_AMOUNT = English.Expenses.TEXT_AMOUNT,
    TEXT_DEFAULT_AMOUNT = English.Expenses.TEXT_DEFAULT_AMOUNT,
    TEXT_ENTER_DESCRIPTION = English.Expenses.TEXT_ENTER_DESCRIPTION,
    TEXT_DESCRIPTION = English.Expenses.TEXT_DESCRIPTION,
    TEXT_PROJECT_OPTIONAL = English.Expenses.TEXT_PROJECT_OPTIONAL,
    TEXT_COMMENTS_OPTIONAL = English.Expenses.TEXT_COMMENTS_OPTIONAL,
    BUTTON_DELETE = English.Expenses.BUTTON_DELETE,
    BUTTON_SAVE = English.Expenses.BUTTON_SAVE,
    TEXT_DELETE_EXPENSE = English.Expenses.TEXT_DELETE_EXPENSE,
    TEXT_MODAL_DELETE_EXPENSE_DESCRIPTION = English.Expenses.TEXT_MODAL_DELETE_EXPENSE_DESCRIPTION,
    BUTTON_MODAL_DELETE_EXPENSE_YES = English.Expenses.BUTTON_MODAL_DELETE_EXPENSE_YES,
    BUTTON_MODAL_DELETE_EXPENSE_NO = English.Expenses.BUTTON_MODAL_DELETE_EXPENSE_NO,
    TEXT_SELECT_PROJECT = English.Expenses.TEXT_SELECT_PROJECT
  } = LanguageData || {};

  useEffect(() => {
    if (props?.editListItemDetails) {
      setPictures(props?.editListItemDetails?.pictureList ?? []);
      setSelectedProjectDetails(props?.editListItemDetails);
      const { id, description, comments, expenseDate, totalAmount } = props?.editListItemDetails;
      setAddexpensesData({
        expenseId: id,
        expDate: dayjs(expenseDate),
        amount: totalAmount,
        description: description,
        comments: comments
      });
    }
  }, [props?.editListItemDetails]);

  const onClose = () => {
    setPictures([]);
    setSelectedProjectDetails([]);
    setDeletedImages([]);
    setBtnLoading(false);
    return props?.onClose();
  };

  function handleChooseFile(event) {
    const files = event.target.files;
    let allFilesValid = true;
    if (files?.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (!files[i].type.startsWith("image/")) {
          allFilesValid = false;
          break;
        }
      }
    }
    if (!allFilesValid) {
      return dispatch(
        setShowalert({
          showAlert: true,
          text: " Please select valid image files (JPEG, PNG, GIF, etc.)."
        })
      );
    }
    let images = [];
    for (let i = 0; i < files?.length; i++) {
      images.push(files[i]);
    }
    setPictures([...pictures, ...images]);
    event.target.value = null;
  }

  const onDeletePicturePressed = (picItem, picIndex) => {
    if (picItem?.id) {
      setDeletedImages([...deletedImages, picItem]);
    }
    let updatePicturesList = pictures.filter((item, index) => index !== picIndex);
    setPictures(updatePicturesList);
  };

  const handleDeleteExpense = async () => {
    try {
      const deleteExpense = {
        UserId: Number(loginData?.userInformation?.UserId),
        ReturnRecordId: false,
        ReturnRecordError: true,
        DeleteList: [
          {
            Id: addExpensesData?.expenseId,
            ModifiedBy: Number(loginData?.userInformation?.UserId)
          }
        ]
      };
      const deleteExpenseRes = await Postrequestcall(
        DELETE_EXPENSES,
        deleteExpense,
        loginData?.accessToken
      );

      if (deleteExpenseRes?.status === 201 && deleteExpenseRes?.data?.message === "OK") {
        setConfirmDeleteExpenseModal(false);
        onClose();
        props?.fetchExpenses(1);
        props?.setShowEditExpensesModal(false);
        props?.setSaveExpensesFlag(false);
      } else if (deleteExpenseRes?.data?.errorMessage) {
        let alertObj = {
          showAlert: true,
          title: "",
          text: deleteExpenseRes?.data?.errorMessage
        };
        dispatch(setShowalert(alertObj));
      }
      props?.onClose();
    } catch (err) {
      console.log("handleDeleteExpense-> Error When Deleting Expenses: ", err);
    }
  };

  const validation = () => {
    let isValid = true;
    if (addExpensesData?.description?.length > 200) {
      setErrorMsg("Maximum 200 characters allowed");
      isValid = false;
    } else {
      setErrorMsg("");
    }
    return isValid;
  };

  const onSaveAddexpenses = async () => {
    try {
      if (validation() === false) {
        return;
      }
      setBtnLoading(true);
      if (deletedImages?.length !== 0) {
        await Promise.all(
          deletedImages.map(async (item) => {
            const deleteObj = {
              UserId: Number(currentUserId),
              ReturnRecordId: false,
              ReturnRecordError: true,
              SoftDelete: true,
              DeleteList: [
                {
                  Id: item.id,
                  ModifiedBy: Number(currentUserId)
                }
              ]
            };
            await Postrequestcall(DELETE_EXPENSES_PICTURES, deleteObj, loginData?.accessToken);
          })
        );
      }
      const saveExpensObj = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: addExpensesData?.expenseId || 0,
            ExpenseDate: addExpensesData?.expDate,
            TotalAmount: Number(addExpensesData?.amount),
            Description: addExpensesData?.description,
            SiteId: selectedProjectDetails?.siteId,
            ProjectId: selectedProjectDetails?.projectId,
            Comments: addExpensesData?.comments,
            IsSent: false,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      const saveExpensesRes = await Postrequestcall(
        SAVE_EXPENSES,
        saveExpensObj,
        loginData?.accessToken
      );

      if (saveExpensesRes?.status === 201) {
        if (pictures?.length > 0) {
          const newPictureList = pictures?.filter((pic) => !pic.pictureUrl);
          if (newPictureList && newPictureList.length > 0) {
            const promises = newPictureList.map(async (img) => {
              const imageFile = img;
              const formData = new FormData();
              formData.append("Id", 0);
              formData.append(
                "ExpenseId",
                saveExpensesRes?.data?.data[0]?.objData?.id || addExpensesData?.expenseId
              );
              imageFile && formData.append("PictureUrl", imageFile);
              formData.append("ModifiedBy", Number(loginData?.userInformation?.UserId));
              await Fileuploadrequestcall(
                SAVE_EXPENSES_PICTURES,
                formData,
                loginData?.accessToken
              ).catch((err) => {
                if (err === "Content Inappropriate") {
                  alert(
                    "The text picture you entered has been automatically identified as inappropriate. Please remove the content and try again."
                  );
                }
              });
            });
            await Promise.all(promises);
          }
        }
      }
      if (props?.editListItemDetails) {
        props?.setSaveExpensesFlag(true);
      } else {
        if (getPath === "home") {
          await refreshExpensesDashboard();
        } else {
          props?.fetchExpenses(1);
          props?.setSaveExpensesFlag(false);
        }
      }
      setBtnLoading(false);
      onClose();
    } catch (err) {
      setBtnLoading(false);
      console.log("onSaveAddexpenses-> Error When Saving Expenses: ", err);
    }
  };

  const refreshExpensesDashboard = async () => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 3,
        FullSearch: "",
        UserId: Number(loginData?.userInformation?.UserId),
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        SearchList: [{ UserId: Number(loginData?.userInformation?.UserId) }],
        SortList: [
          {
            FieldName: "dateCreated",
            Direction: "desc"
          }
        ]
      };
      const fetchExpensesRes = await Postrequestcall(FETCH_EXPENSES, obj, loginData?.accessToken);
      if (fetchExpensesRes?.status === 200) {
        dispatch(setDashboardData({ ...dashboardData, expenses: fetchExpensesRes?.data?.data }));
      }
    } catch (error) {
      console.log("refreshExpensesDashboard-> Error Fetching Expenses: ", error);
    }
  };

  const onSelectProject = (item) => {
    setSelectedProjectDetails(item);
  };

  const handleDateChange = (date) => {
    setAddexpensesData({
      ...addExpensesData,
      expDate: date
    });
  };

  const handleInputchange = (e) => {
    setErrorMsg("");
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setAddexpensesData({
      ...addExpensesData,
      [e.target.name]: inputValue
    });
  };

  const onAmountChange = (val) => {
    try {
      if (val === "." || val === "0") return;
      if (val.startsWith("0") && val?.length > 1) {
        val = val.replace(/^0+/, "0");
      }
      let numericValue = val.replace(/[^0-9.]/g, "");
      if (numericValue.includes(".")) {
        const [beforeDecimal, afterDecimal] = numericValue.split(".");
        numericValue = beforeDecimal.slice(0, 4) + "." + afterDecimal.slice(0, 2);
      } else {
        numericValue = numericValue.slice(0, 4);
      }
      setAddexpensesData({
        ...addExpensesData,
        amount: numericValue
      });
    } catch (error) {
      console.log("onAmountChange-> Error Handling Amount Change: ", error);
    }
  };

  const isSaveBtnDisable = () => {
    return (
      !addExpensesData?.description.trim() ||
      !addExpensesData?.amount ||
      isNaN(Number(addExpensesData?.amount)) ||
      !addExpensesData?.expDate
    );
  };

  return (
    <>
      <Modal open={props?.isOpen}>
        <Box className="user-modal-responsive">
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between"
            }}>
            <Typography variant="h6">
              {props?.editListItemDetails ? TEXT_EDIT_EXPENSES : TEXT_ADD_EXPENSES}
            </Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Stack spacing={isSmallScreen ? 1 : 1.5}>
            {pictures?.length !== 0 ? (
              <>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={1} sx={{ alignItems: "center" }}>
                    <Grid
                      size={{ xs: 3.5, sm: 2.8, md: 2.8 }}
                      sx={{ height: isSmallScreen ? 90 : 130 }}>
                      <Button
                        sx={{
                          width: "100%",
                          height: "100%",
                          color: "GrayText",
                          borderRadius: "10px",
                          backgroundColor: "lightgray",
                          boxShadow: "none",
                          textAlign: "center",
                          p: 0
                        }}
                        variant="text"
                        size="small"
                        component="label">
                        <ImageIcon /> {TEXT_ADD_PICTURES}
                        <input
                          id="timeSheetPicture-upload"
                          type="file"
                          multiple
                          accept="image/*"
                          onChange={(e) => handleChooseFile(e)}
                          hidden
                        />
                      </Button>
                    </Grid>

                    <Grid
                      size={{ xs: 8.5, sm: 9.2, md: 9.2 }}
                      sx={{ height: isSmallScreen ? 90 : 130 }}>
                      <ImageList
                        gap={7.5}
                        sx={{
                          width: "100%",
                          height: "100%",
                          margin: 0,
                          padding: 0,
                          flexWrap: "nowrap",
                          overflowX: "auto",
                          display: "flex",
                          pb: 0.5,
                          borderRadius: "10px",
                          backgroundColor: "white"
                        }}>
                        {pictures.map((picItem, picIndex) => (
                          <ImageListItem key={picIndex} sx={{ minWidth: isSmallScreen ? 90 : 130 }}>
                            <img
                              src={picItem?.id ? picItem?.pictureUrl : URL.createObjectURL(picItem)}
                              style={{
                                borderRadius: 10,
                                width: isSmallScreen ? 90 : 130,
                                height: isSmallScreen ? 90 : 130,
                                objectFit: "cover",
                                cursor: "pointer"
                              }}
                              alt="Expenses"
                              loading="lazy"
                              onClick={() => {
                                setImageIndex(picIndex);
                                setPictureViewer(true);
                              }}
                            />
                            <ImageListItemBar
                              sx={{ background: "none", padding: 1 }}
                              position="top"
                              actionIcon={
                                <IconButton
                                  aria-label="delete image"
                                  onClick={() => onDeletePicturePressed(picItem, picIndex)}
                                  size="small"
                                  sx={{
                                    color: "white",
                                    backgroundColor: "rgba(0,0,0,0.3)"
                                  }}>
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              }
                              actionPosition="right"
                            />
                          </ImageListItem>
                        ))}
                      </ImageList>
                    </Grid>
                  </Grid>
                </Box>
              </>
            ) : (
              <Button
                sx={{
                  width: "100%",
                  color: "GrayText",
                  height: 100,
                  backgroundColor: "lightgray",
                  boxShadow: "none"
                }}
                startIcon={<ImageIcon />}
                variant="contained"
                size="small"
                component="label">
                {TEXT_ADD_PICTURES}
                <input
                  id="timeSheetPicture-upload"
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={(e) => handleChooseFile(e)}
                  hidden
                />
              </Button>
            )}
            <Stack sx={{ pt: 0.5 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  enableAccessibleFieldDOMStructure={false}
                  open={openDatepicker}
                  onOpen={() => setOpenDatepicker(true)}
                  onClose={() => setTimeout(() => openDatepicker && setOpenDatepicker(false), 100)} // Prevents blinking
                  onChange={(date) => {
                    handleDateChange(date);
                    setOpenDatepicker(false);
                  }}
                  value={addExpensesData?.expDate}
                  maxDate={dayjs()}
                  format="MMM DD, YYYY"
                  label={TEXT_EXPENSE_DATE}
                  slots={{ openPickerIcon: CalendarIcon }} // New way to add the calendar icon
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "medium",
                      onClick: () => setOpenDatepicker(true)
                    },
                    openPickerButton: {
                      onClick: (e) => {
                        e.stopPropagation();
                        setOpenDatepicker((prev) => !prev); // Toggle picker
                      }
                    },
                    popper: {
                      disablePortal: true // Ensures it stays inside the parent container
                    }
                  }}
                />
              </LocalizationProvider>
            </Stack>

            <TextField
              label={TEXT_AMOUNT}
              type="text"
              placeholder={TEXT_DEFAULT_AMOUNT}
              fullWidth
              value={addExpensesData?.amount}
              onChange={(e) => {
                onAmountChange(e.target.value);
              }}
              slots={{
                input: Input // import from @mui/base or @mui/material depending on use
              }}
              slotProps={{
                input: {
                  startAdornment:
                    addExpensesData?.amount?.toString()?.trim()?.length !== 0 ? (
                      <InputAdornment position="start">$</InputAdornment>
                    ) : null
                }
              }}
            />
            <TextField
              label={TEXT_DESCRIPTION}
              fullWidth
              type="text"
              value={addExpensesData?.description}
              placeholder={TEXT_ENTER_DESCRIPTION}
              name="description"
              variant="outlined"
              onChange={(e) => handleInputchange(e)}
            />
            <InputLabel style={{ color: "#ff0000", marginTop: "7px", fontSize: "13px" }}>
              {errorMsg}
            </InputLabel>
            <TextField
              label={TEXT_PROJECT_OPTIONAL}
              placeholder={TEXT_SELECT_PROJECT}
              fullWidth
              type="text"
              name="project"
              value={selectedProjectDetails?.projectName || ""}
              variant="outlined"
              onClick={() => setShowProjects(true)}
            />
            <TextField
              label={TEXT_COMMENTS_OPTIONAL}
              minRows={2}
              slotProps={{
                input: {
                  multiline: true,
                  inputComponent: "textarea"
                }
              }}
              fullWidth
              type="text"
              value={addExpensesData?.comments}
              placeholder={TEXT_COMMENTS_OPTIONAL}
              name="comments"
              variant="outlined"
              onChange={(e) => handleInputchange(e)}
            />
            <Stack direction={"row"} spacing={2}>
              {props?.editListItemDetails?.id && (
                <Button
                  variant="outlined"
                  fullWidth
                  color="error"
                  disabled={btnLoading}
                  onClick={() => setConfirmDeleteExpenseModal(true)}>
                  {BUTTON_DELETE}
                </Button>
              )}
              <Button
                variant="contained"
                fullWidth
                onClick={onSaveAddexpenses}
                loading={btnLoading}
                startIcon={<SaveIcon />}
                disabled={isSaveBtnDisable()}>
                {BUTTON_SAVE}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>

      {showProjects && (
        <Projectlist
          isOpen={showProjects}
          onClose={() => setShowProjects(false)}
          onSelectProject={(e) => onSelectProject(e)}
        />
      )}

      {pictureViewer && pictures && (
        <PictureViewer
          isOpen={pictureViewer}
          onClose={() => setPictureViewer(false)}
          pictures={pictures?.map((item, i) => {
            return { src: item?.pictureUrl || URL.createObjectURL(item) };
          })}
          viewerIndex={imageIndex}
        />
      )}

      {confirmDeleteExpenseModal && (
        <PromptModal
          isOpen={confirmDeleteExpenseModal}
          onClose={() => setConfirmDeleteExpenseModal(false)}
          title={TEXT_DELETE_EXPENSE}
          desc={TEXT_MODAL_DELETE_EXPENSE_DESCRIPTION}
          redButtonText={BUTTON_MODAL_DELETE_EXPENSE_YES}
          blueButtonText={BUTTON_MODAL_DELETE_EXPENSE_NO}
          onRedButtonClick={() => handleDeleteExpense()}
          onBlueButtonClick={() => setConfirmDeleteExpenseModal(false)}
        />
      )}
    </>
  );
};

export default Addexpenses;
